<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'module.title' | translate }}</h4>
      <p class="mb-0">{{ 'module.text' | translate: currentObject }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #moduleForm="ngForm" (ngSubmit)="onSubmit(moduleForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'module.detailsHeader' | translate }}
            </h4>

            <!-- ModuleId -->
            <div class="form-group">
              <label for="ModuleId">{{ 'module.idFieldLabel' | translate }}</label>
              <input class="form-control" name="ModuleId" #ModuleId="ngModel" [(ngModel)]="currentObject.ModuleId"
                     placeholder="{{'module.idFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- Name -->
            <div class="form-group">
              <label for="Name">{{ 'module.nameFieldLabel' | translate }}</label>
              <input class="form-control" name="Name" value="{{currentObject.Name}}"
                     placeholder="{{'module.nameFieldPlaceHolder' | translate}}"
                     required readonly="readonly">
            </div>

            <!-- DefaultTransactionFee -->
            <div class="form-group">
              <label>{{ 'module.defaultTransactionFeeFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input type="number" min="0" class="form-control module-input" name="DefaultTransactionFee"
                       #DefaultTransactionFee="ngModel" [(ngModel)]="currentObject.DefaultTransactionFee"
                       placeholder="{{'module.defaultTransactionFeeFieldPlaceHolder' | translate}}" required>
              </div>
            </div>

            <!-- DefaultRefundCost -->
            <div class="form-group">
              <label>{{ 'module.defaultRefundCostFieldLabel' | translate }}</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">€</span>
                </div>
                <input type="number" min="0" class="form-control module-input" name="DefaultRefundCost"
                       #DefaultRefundCost="ngModel" [(ngModel)]="currentObject.DefaultRefundCost"
                       placeholder="{{'module.defaultRefundCostFieldPlaceHolder' | translate}}" required>
              </div>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-warning mr-1" type="button" (click)="resetForm(moduleForm)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [disabled]="!moduleForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
              <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
